import React from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import Checkbox from '../../../../library/checkbox/checkbox';

import {
  useCompareProducts,
  useProductEntryDataLayerValues
} from '../../../../shared/hooks/hooks';

import { trackAction } from '../../../../shared/utils/analytics/analytics';

import './compare-checkbox.scss';

function CompareCheckbox(props) {
  const { className, hideSelectMoreText, product, quantity, rearQuantity } =
    props;

  const { search } = useLocation();
  const { page } = queryString.parse(search);

  const {
    maxProductsForComparison,
    onProductComparison,
    productsForComparison
  } = useCompareProducts();

  const { getProductEntryDataLayerValues } = useProductEntryDataLayerValues();

  const selectedProducts = productsForComparison ? productsForComparison : [];
  const numProductsSelected = selectedProducts.length;
  const isSelectedForComparison = selectedProducts.some(
    p =>
      p?.code === product?.code &&
      p?.rearProduct?.code === product?.rearProduct?.code
  );
  const isDisabled =
    !isSelectedForComparison && numProductsSelected >= maxProductsForComparison;
  const moreProductsToSelect = maxProductsForComparison - numProductsSelected;

  function handleCheckboxClick() {
    onProductComparison(
      product,
      !isSelectedForComparison,
      quantity,
      rearQuantity,
      page
    );
    trackAction(
      `product_list_compare_${isSelectedForComparison ? 'remove' : 'add'}`,
      getProductEntryDataLayerValues(product)
    );
  }

  return (
    <div
      className={`${className || ''} compare-checkbox`}
      styleName="container"
    >
      <div
        className={`compare-checkbox__compare-container ${
          isDisabled ? 'compare-checkbox__compare-container--disabled' : ''
        }`}
        styleName="compare-container"
      >
        <Checkbox
          id="compare-btn"
          isChecked={isSelectedForComparison}
          isDisabled={isDisabled}
          label="Compare"
          onClick={handleCheckboxClick}
        />
      </div>

      {!hideSelectMoreText &&
        isSelectedForComparison &&
        moreProductsToSelect > 0 && (
          <span styleName="select-more">
            {moreProductsToSelect === 1
              ? 'select 1 more'
              : `select up to ${moreProductsToSelect} more`}
          </span>
        )}
    </div>
  );
}

CompareCheckbox.propTypes = {
  className: PropTypes.string,
  hideSelectMoreText: PropTypes.bool,
  product: PropTypes.object,
  quantity: PropTypes.number,
  rearQuantity: PropTypes.number
};
export default CompareCheckbox;
